import { render, staticRenderFns } from "./Startseite1.vue?vue&type=template&id=4c77215a&scoped=true&"
import script from "./Startseite1.vue?vue&type=script&lang=js&"
export * from "./Startseite1.vue?vue&type=script&lang=js&"
import style0 from "./Startseite1.vue?vue&type=style&index=0&id=4c77215a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c77215a",
  null
  
)

export default component.exports